// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2Zt0q","buttons":"SendReceipts_buttons__2lJkQ","email":"SendReceipts_email__18h_O","bookApptTitle":"SendReceipts_bookApptTitle__1QSEc"};